
import React, { useEffect } from 'react';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import SunEditor, { buttonList } from "suneditor-react";
import parse from 'html-react-parser';


const MyTextArea = (props) => {

    const lbl = (props.lbl != null) ? (
        <p className={props.lblCss}>{props.lbl}</p>
    ) : "";

    return (
        <>
            {lbl}
            <textarea className={props.cssStyle} lang="he"
                onChange={(e) => props.saveEditorTxt(e.target.value)}
                style={props.styl}
                value={props.firstText}
                placeholder={props.placeholder}>
                {props.firstText}
            </textarea >

        </>

    )
}

export default MyTextArea